var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargersOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.1162087 4.90899319-2.4917588-1.65483244c-.6894415-.45614039-1.6340308-.28110901-2.0954675.38718802l-12.214508 17.59850723-5.61324605-5.4842851c-.58629642-.5728267-1.54174244-.5728267-2.12803886 0l-2.13346718 2.084452c-.58629641.5728266-.58629641 1.5063219 0 2.0844534l8.63158549 8.4332801c.4831527.4720512 1.2431666.8327198 1.9271784.8327198.6840132 0 1.3734533-.4190111 1.818605-1.0501815l14.7008398-21.18928105c.466865-.66829704.2877192-1.58588143-.4017223-2.04202046z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargersOnline);
export default __webpack_public_path__ + "static/media/Chargers Online.517ec792ef02af4721539f4df6c95c36.svg";
export { ForwardRef as ReactComponent };